import { combineReducers } from 'redux';
// import employeesReducer from './Employees';

// reducers
const appReducer = combineReducers({
  //   routing: routerReducer,
  //   form: formReducer,
  // employees: employeesReducer,
});

export default appReducer;
